import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const Item = (props) => {
	const { t, i18n } = useTranslation();

	const {hook_id, item, index, offerData} = props;

	var display_full = (item.remaining === 0) ? 'full' : '';
	const isDisabled = item.remaining === 0;

	const handleLabelClick = (e) => {
		if (isDisabled) {
			e.preventDefault();
			e.stopPropagation();
		}
	};

	return (
		<label htmlFor={`hook-offer-item-id-${index}`} onClick={handleLabelClick} style={isDisabled ? { cursor: 'not-allowed', pointerEvents: 'auto' } : {}}>
			<input
				type="radio"
				id={`hook-offer-item-id-${index}`}
				name="page_user_hook_offer_item[hook_offer_item_id]"
				className="hook-offer-id"
				value={item._id}
				required={!isDisabled}
				disabled={isDisabled}
				data-fv-not-empty___message={t('此欄為必須填寫')}
				defaultChecked={offerData.user_data && offerData.user_data?.page_user_hook_offer_item?.hook_offer_item_id === item._id}
			/>
			<div className={`option ${display_full}`}>
				<div className="opt_line align-items-center flex-nowrap">
					<div className="sim-radio"></div>
					{item.cover_img && (
						<div className="flex-shrink-0 w-80px mx-3 ratio ratio-16x9 position-relative">
							<img src={item.cover_img} alt="" className="imgfit rounded" />
						</div>
					)}
					<div className="flex-grow-1 flex-shrink-1">
						<div className="session-top">
							<div className="session_name">
								<span>{item.name}</span>
							</div>
							{item.description && (
								<div className="seesion_desc fz12 text-muted">
									{item.description}
								</div>
							)}
						</div>
					</div>
				</div>
				{item.remaining === 0 && (
					<span className="text-white fz12 badge bg-dark position-absolute start-50 top-50 translate-middle h-20px w-auto text-center">{t('索取一空')}</span>
				)}
			</div>
		</label>
	);
}

export default Item;